import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../types/interfaces'
import { russiaCenter } from '../../../utils/constants'
import scale from '../../../../assets/images/icons/scale.svg'
import logo from '../../../../assets/images/logo_grey.png'
import light_map from '../../../../assets/images/light_map.webp'
import dark_map from '../../../../assets/images/dark_map.webp'

import classes from './GMapForMarkers.module.sass'
import { useGmapForMarkers } from './hooks/useGmapForMarkers'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../store/slices/settingsSlice'

type Props = {
  list: SlotItemInterface[] | TransportItemInterface[] | CargoItemInterface[] | []
}

export const GMapForMarkers = ({ list }: Props) => {
  const { visible, toggleMap, resetBounds } = useGmapForMarkers(russiaCenter, list)
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      style={{
        backgroundImage:
          !visible && darkTheme ? `url(${dark_map})` : !visible ? `url(${light_map})` : '',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
      className={visible ? classes.Container : classes.ContainerHidden}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        id="map"
        className={classes.Map}
        style={{ zIndex: 1 }}
        onClick={(e) => e.stopPropagation()}
      />
      <div className={classes.ButtonAnchor}>
        <div className={classes.SlideButton} onClick={toggleMap}>
          <div className={classes.SlideButtonHandle} />
        </div>
      </div>
      <div className={classes.ScaleButtonAnchor}>
        <img src={logo} className={classes.Logo} alt="logid" />
        {visible && (
          <div className={classes.ScaleIconContainer} onClick={resetBounds}>
            <img src={scale} alt="Сбросить зум" className={classes.ScaleIcon} />
          </div>
        )}
      </div>
    </div>
  )
}
